import React from "react";
import "./EstimateOverviewElementDetails.css";
import { editConfiguration } from "_store/configurations/service";
import EstimateOverviewButton from "components/Buttons/EstimateOverviewButton/EstimateOverviewButton";
import { useActivePage } from "_store/page/selectors";
import { useGetLocalizationText } from "_store/localization/selectors";
import { priceFormater } from "__utilities/functions/Public";

export default function EstimateOverviewElementDetails({
  key,
  configurationId,
  title,
  details,
  code,
  quantity,
  price,
  isEditable,
  stepNumber,
  image = null,
  regionObj,
  flexWrapItem = false
}) {
  const {setPage} = useActivePage();
  const getLocalizationText = useGetLocalizationText();

  return (
    <div key={key} className={`config-cabinet-summary-${flexWrapItem ? "small" : "big"}-item-container`}>
      <div className="config-cabinet-summary-item-container-left">
        <img className="config-summary-item-img" src={image} alt="" />
        <div>
          <div className="config-cabinet-summary-item-title">
            {quantity > 1 && `${quantity} x `}{title}
          </div>
          {details && <div className="config-cabinet-summary-item-title">
            {details}
          </div>}
          {price && <div className="config-cabinet-summary-item-title">
            {priceFormater(
                          price?.amount,
                          price?.currencyCode,
                          regionObj?.localizationISOCode,
                          regionObj?.currencyPosition
                        )}
          </div>}
        </div>
      </div>
      <div className="config-cabinet-summary-item-code">{code}</div>
      {isEditable && <div className="config-cabinet-summary-item-container-button">
        <EstimateOverviewButton
          toolTipText={getLocalizationText("EstimateOverview_Button_Edit")}
          onClick={() => {
            editConfiguration(configurationId, () => {
              setPage(stepNumber);
            });
          }}
        >
          <span className="estimate-overview-configuration-button-edit"></span>
        </EstimateOverviewButton>
      </div>}
    </div>
  );
}
